import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { errorMessagesMap } from 'src/app/constants/error-messages';
import { Alert } from 'src/app/interfaces/alert';
import { User } from 'src/app/interfaces/user';
import { SmartTagLimit, SmartTagOrderItem } from 'src/app/interfaces/smart-tag';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { LogService } from 'src/app/services/common/log.service';
import { SmartTagService } from 'src/app/services/smart-tag/smart-tag.service';
import { PetService } from 'src/app/services/pet/pet.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-identi-smart-tag-product-page',
  templateUrl: './identi-smart-tag-product-page.component.html'
})
export class IdentiSmartTagProductPageComponent implements OnInit {

  /** How many free tags the keeper has left. Null until the backend answers. */
  public tagPricing: SmartTagLimit | null = null;

  public alert: Alert = null;

  public tagUnitPrice: number;

  /** Names the pets in the page title. Keepers with no pet keep the fallback. */
  public petName = 'your pet';

  private isBrowser: boolean;

  constructor(
    private smartTagService: SmartTagService,
    private checkoutService: CheckoutService,
    private configService: ConfigService,
    private petService: PetService,
    private logService: LogService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.tagUnitPrice = this.configService.getNumberFromKey('3-plan-tag-unit-price');

    const user: User = this.route.snapshot.data['user'];
    this.petName = this.petService.createPetsListString(user?.pets) || this.petName;
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.loadTagLimit();
    }
  }

  /** Loads tag limit. */
  private loadTagLimit(): void {
    this.smartTagService.getSmartTagLimit().subscribe({
      next: (limit) => this.tagPricing = limit,
      error: (err) => {
        this.logService.error(errorMessagesMap.smart_tag_limit_error, err);
        this.setAlert('danger', errorMessagesMap.generic_error_message);
      },
    })
  }

  // Continue with the free tags only (trims paid ones)
  onContinueFreeOnly(freeTags: SmartTagOrderItem[]): void {
    this.smartTagService.orderFreeTags(freeTags).subscribe({
      next: () => { 
        this.setAlert('success', errorMessagesMap.smart_tag_free_request_success);
        // redirect to dashboard after 3 seconds
        setTimeout(() => this.router.navigate(['/dashboard']), 3000);
      },
      error: (err) => {
        this.logService.error(errorMessagesMap.smart_tag_free_request_error, err);
        this.setAlert('danger', errorMessagesMap.smart_tag_free_request_error);
      }
    });
  }

  // Continue with all tags, paying for the extras. 
  // each tag is labelled by its own orderType.
  onContinueWithPayment(tags: SmartTagOrderItem[]): void {
    this.checkoutService
      .checkout([environment.stripePlans.smartTagPhysicalProduct], { smartTag: { tags } })
      .subscribe({
        error: () => {
          this.setAlert('danger', errorMessagesMap.generic_error_message);
        }
      });
  }

  // Error handling helpers

  private setAlert(type: string, message: string): void {
    this.alert = {
      type,
      message,
    };
  }

  closeAlert() {
    this.alert = null;
  }
}
